import { Skeleton as RadixSkeleton } from "@radix-ui/themes/components/skeleton";
import type { CSSProperties, ReactNode } from "react";
import { cn } from "../../lib/utils";

export interface SkeletonProps {
  className?: string;
  style?: CSSProperties;
  /** Wrapped content keeps its own size while hidden behind the placeholder. */
  children?: ReactNode;
}

/**
 * Pulsing placeholder for content that is still loading. Size it with
 * utility classes; Radix's own width/height props rely on the Radix Themes
 * utility stylesheet, which this app does not load. An empty skeleton gets a
 * default height from Radix, so add `h-auto` when sizing by aspect ratio.
 */
export function Skeleton(props: Readonly<SkeletonProps>) {
  return (
    <RadixSkeleton className={cn("block", props.className)} style={props.style}>
      {props.children}
    </RadixSkeleton>
  );
}
